import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import ScrollToTop from '@/components/base/ScrollToTop';
import PlatformCard from '@/components/base/PlatformCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import { platforms } from '@/mocks/platforms';
import { categories } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const filteredPlatforms = platforms.filter((p) => p.category === slug);

  const categoryTitle = currentCategory?.name || '分类';
  const categoryDesc = currentCategory?.description || '';

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`${categoryTitle} - 免费看片平台推荐 | 免费看片合集2024`}
        description={`${categoryDesc} 精选正版免费看片平台，免费看片不卡顿，高清免费看片资源一站直达。`}
        keywords={`免费看片,${categoryTitle},免费看片平台推荐,正版免费看片网站,高清免费看片资源`}
        canonicalUrl={`https://mianfeikanpian.com/category/${slug}`}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <div className="pt-16 bg-background-100 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={[
              { label: '首页', path: '/' },
              { label: categoryTitle },
            ]} />
            <div className="px-4 md:px-6 pb-8">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
                  <i className={`${currentCategory?.icon || 'ri-global-line'} text-lg text-primary-600`}></i>
                </div>
                <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">{categoryTitle}</h1>
              </div>
              {categoryDesc && (
                <p className="text-sm text-foreground-600 max-w-2xl">{categoryDesc}</p>
              )}
            </div>
          </div>
        </div>

        {/* Category Tabs */}
        <div className="w-full bg-background-50 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex gap-1 overflow-x-auto py-3 scrollbar-hide">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Platform List */}
        <section className="w-full py-10">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            {filteredPlatforms.length > 0 ? (
              <>
                <p className="text-sm text-foreground-500 mb-6">
                  共找到 <strong className="text-foreground-900">{filteredPlatforms.length}</strong> 个平台
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {filteredPlatforms.map((platform) => (
                    <PlatformCard key={platform.id} {...platform} />
                  ))}
                </div>
              </>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                  <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-600">该分类暂无平台，请查看其他分类</p>
                <Link
                  to="/category/zonghe"
                  className="inline-block mt-4 px-6 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看综合平台
                </Link>
              </div>
            )}
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}